import { Box, Grid, Modal, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import styled from "styled-components";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../../../../../_metronic/_assets/sass/custom/globalColors";
import InputForm from "../../../../../../../../components/InputForm";
import Loading from "../../../../../../../home/components/Loading";

const Button = styled.button`
  position: relative;
  width: ${({ submitText }) => (submitText ? "200px" : "150px")};
  height: 48px;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  text-transform: uppercase;

  padding: 0;

  background: #fff;
  margin-right: 8px;
  border-radius: 4px;
  color: ${({ color }) => (color ? color : "#4D4C4D")};
  border: ${({ color }) =>
    color ? `1px solid ${color}` : "1px solid #4D4C4D"};

  border-radius: 4px;
  transition: filter 0.4s;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    text-decoration: ${({ variant }) =>
      variant === "cancel" ? "underline" : ""};
  }

  &:hover {
    filter: brightness(90%);
    cursor: pointer;
  }

  &:disabled {
    background: ${globalColors.textColor3};
    cursor: not-allowed;
    border-color: ${({ color }) =>
      color ? globalColors.textColor3 : "#4D4C4D88"};
  }

  ${({ variant }) =>
    variant === "primary"
      ? `
    background: ${globalColors.primaryColor2};
    color: white;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
    margin-right: 0px;
    `
      : variant === "cancel" &&
        `
      background: transparent;
      color: ${globalColors.primaryColor2};
      border-color: transparent
    `};
`;

export const RejectingDocumentModal = (props) => {
  const [loading, setLoading] = useState(false);

  const handleRejectDocument = useCallback(async () => {
    setLoading(true);
    try {
      await props.rejectDocument(props?.rejectingDocumentId);
      props.handleOpen(false);
    } catch (e) {
      Swal.fire("Erro!", "Erro ao rejeitar documento.", "error");
    } finally {
      setLoading(false);
    }
  }, [props]);

  function validSubmit() {
    return props?.observationReject?.length > 3;
  }

  return (
    <>
      <Modal
        open={props?.open}
        onClose={() => props.handleOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              padding: 4,
              borderRadius: 2,
              boxShadow: 24,
              width: 700,
              height: 321,
            }}
          >
            <Typography
              variant="h5"
              id="modal-modal-title"
              component="h2"
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                textAlign: "center",
              }}
            >
              Confirmação de Rejeição
            </Typography>
            <InputForm
              label="Digite o motivo *"
              value={props?.observationReject}
              onChange={(e) => props.setObservationReject(e)}
              required={true}
              withoutTextTransform
            />
            <Grid
              container
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Button
                color={globalColors.primaryColor2}
                onClick={() => props.handleOpen(false)}
              >
                Cancelar
              </Button>
              <Button
                variant="primary"
                type="submit"
                color={globalColors.primaryColor2}
                onClick={handleRejectDocument}
                disabled={!validSubmit()}
              >
                {loading ? <Loading isLoading={loading} /> : "Confirmar"}
              </Button>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default RejectingDocumentModal;
